import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IRegistrationPayload,
} from '../types';
import {
  REGISTER_MUTATION_KEY,
  REGISTER_URL,
  REGISTRATION_PERMISSIONS,
} from '../constants';

export default function useRegisterMutation(): IContextMutationResult<void, Error, IRegistrationPayload> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IRegistrationPayload>({
    mutationKey: [REGISTER_MUTATION_KEY],
    mutationFn: (affiliate) => fetchPost<void>(REGISTER_URL, { affiliate }, {
      permission: REGISTRATION_PERMISSIONS.REGISTER,
    }),
  });
}
